import React, { useEffect, useState, useCallback } from "react";

const API = "https://vms.hexagons.tech/api";

// 🔥 MAPEO DE ESTADOS
const statusMap = {
  inside: "Dentro",
  exited: "Salida"
};

export default function Visitor() {
  const [visitors, setVisitors] = useState([]);

  const [form, setForm] = useState({
    name: "",
    idNumber: "",
    company: "",
    department: "",
    reason: "",
    reasonDetail: ""
  });

  const token = localStorage.getItem("token");

  const fetchVisitors = useCallback(async () => {
    try {
      const res = await fetch(`${API}/visitors`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("Error fetchVisitors:", text);
        return;
      }

      const data = await res.json();
      setVisitors(Array.isArray(data) ? data : []);

    } catch (err) {
      console.error("fetchVisitors error:", err);
    }
  }, [token]);

  useEffect(() => {
    if (token) fetchVisitors();
  }, [fetchVisitors, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.idNumber || !form.reason) {
      alert("Complete los campos obligatorios");
      return;
    }

    try {
      const res = await fetch(`${API}/visitors`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(form)
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("Error POST visitor:", text);
        alert("Error al registrar visitante");
        return;
      }

      setForm({
        name: "",
        idNumber: "",
        company: "",
        department: "",
        reason: "",
        reasonDetail: ""
      });

      fetchVisitors();

    } catch (err) {
      console.error("handleSubmit error:", err);
    }
  };

  const markExit = async (id) => {
    if (!window.confirm("¿Marcar salida?")) return;

    try {
      const res = await fetch(`${API}/visitors/${id}/exit`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("Error markExit:", text);
        return;
      }

      fetchVisitors();

    } catch (err) {
      console.error("markExit error:", err);
    }
  };

  return (
    <div className="p-4 md:p-6 space-y-6 bg-background min-h-screen">

      <div>
        <h1 className="text-2xl font-bold text-primary">
          Gestión de Visitantes
        </h1>
      </div>

      {/* FORM */}
      <div className="bg-white p-6 rounded-2xl shadow border-l-4 border-primary">
        <h3 className="font-semibold text-primary mb-4">
          Registrar visitante
        </h3>

        <form onSubmit={handleSubmit} className="grid md:grid-cols-3 gap-3">

          <input
            placeholder="Nombre"
            className="border p-3 rounded-lg"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />

          <input
            placeholder="Cédula de Identidad"
            className="border p-3 rounded-lg"
            value={form.idNumber}
            onChange={(e) => setForm({ ...form, idNumber: e.target.value })}
          />

          <input
            placeholder="Empresa que Representa"
            className="border p-3 rounded-lg"
            value={form.company}
            onChange={(e) => setForm({ ...form, company: e.target.value })}
          />

          <input
            placeholder="Departamento / Persona que Visita"
            className="border p-3 rounded-lg"
            value={form.department}
            onChange={(e) => setForm({ ...form, department: e.target.value })}
          />

          <select
            className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-accent outline-none"
            value={form.reason}
            onChange={(e) => setForm({ ...form, reason: e.target.value })}
          >
            <option value="">Motivo de visita</option>
            <option>Entrega de Documentos</option>
            <option>Entrega de Paquetes</option>
            <option>Entrevista</option>
            <option>Retiro de Documentos</option>
            <option>Reunión</option>
            <option>Servicio Técnico</option>
            <option>Otros</option>
             <option>Personal Interno Sin Bagde</option>
          </select>

          {/* 🔥 CAMPO DINÁMICO (AGREGADO) */}
          {[
            "Entrega de Documentos",
            "Entrega de Paquetes",
            "Otros",
            "Entrevista",
            "Reunión",
            "Servicio Técnico",
            "Personal Interno Sin Bagde"
          ].includes(form.reason) && (
            <input
              placeholder={
                ["Entrevista", "Reunión","Servicio Técnico","Personal Interno Sin Bagde"].includes(form.reason)
                  ? "Número de visitante / Badge Temporal"
                  : "Detalle o destinatario"
              }
              className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-accent outline-none"
              value={form.reasonDetail}
              onChange={(e) =>
                setForm({ ...form, reasonDetail: e.target.value })
              }
            />
          )}

          <button className="bg-primary text-white py-3 rounded-lg col-span-full">
            Registrar
          </button>

        </form>
      </div>

      {/* TABLE */}
      <div className="bg-white p-6 rounded-2xl shadow border-l-4 border-secondary">

        <h3 className="font-semibold text-primary mb-4">
          Visitantes registrados
        </h3>

        <table className="min-w-full text-sm">

          <thead className="bg-secondary text-white">
            <tr>
              <th className="p-3 text-left">Nombre</th>
              <th className="p-3 text-left">Cédula</th>
              <th className="p-3 text-left">Empresa</th>
              <th className="p-3 text-left">Detalle</th>

              {/* 🔥 NUEVO */}
              <th className="p-3 text-left">Entrada</th>
              <th className="p-3 text-left">Salida</th>

              <th className="p-3 text-left">Estado</th>
              <th className="p-3 text-left">Acción</th>
            </tr>
          </thead>

          <tbody>
            {visitors.map((v) => (
              <tr key={v._id} className="border-t hover:bg-gray-50">

                <td className="p-3">{v.name}</td>
                <td className="p-3">{v.idNumber}</td>
                <td className="p-3">{v.company}</td>
                <td className="p-3">{v.reasonDetail || "-"}</td>

                {/* 🔥 NUEVO */}
                <td className="p-3">
                  {v.entryTime ? new Date(v.entryTime).toLocaleString() : "-"}
                </td>

                <td className="p-3">
                  {v.exitTime ? new Date(v.exitTime).toLocaleString() : "-"}
                </td>

                <td className="p-3">
                  <span className={`px-2 py-1 rounded text-white text-xs ${
                    v.status === "inside" ? "bg-success" : "bg-gray-500"
                  }`}>
                    {statusMap[v.status] || v.status}
                  </span>
                </td>

                <td className="p-3">
                  {v.status === "inside" && (
                    <button
                      onClick={() => markExit(v._id)}
                      className="bg-red-500 text-white px-3 py-1 rounded"
                    >
                      Salida
                    </button>
                  )}
                </td>

              </tr>
            ))}
          </tbody>

        </table>
      </div>
    </div>
  );
}